/* Gospel Archive — variant picker: selects a real variant, never lets an
   unavailable combination submit, and never guesses a price/format itself
   (formatted strings are rendered server-side per variant). */
(function () {
  'use strict';

  document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-picker-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var optionNames = data.options;
    var form = root.closest('[data-product-info]');
    var hiddenIdInputs = document.querySelectorAll('[data-selected-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var compareEl = document.querySelector('[data-product-compare-price]');
    var addButton = document.querySelector('[data-add-to-cart-button]');
    var addLabel = document.querySelector('[data-add-to-cart-label]');

    function currentSelection() {
      var selection = [];
      root.querySelectorAll('fieldset[data-option-index]').forEach(function (fieldset) {
        var index = parseInt(fieldset.dataset.optionIndex, 10);
        var checked = fieldset.querySelector('[data-option-radio]:checked');
        selection[index] = checked ? checked.value : null;
      });
      return selection;
    }

    function findVariant(selection) {
      return variants.find(function (variant) {
        return variant.options.every(function (value, i) { return value === selection[i]; });
      });
    }

    // A value is selectable if some variant matches it plus the *other*
    // currently-chosen options — this is what prevents choosing a sold-out
    // combination rather than just a globally sold-out value.
    function updateAvailability(selection) {
      root.querySelectorAll('fieldset[data-option-index]').forEach(function (fieldset) {
        var index = parseInt(fieldset.dataset.optionIndex, 10);
        fieldset.querySelectorAll('[data-option-radio]').forEach(function (radio) {
          var testSelection = selection.slice();
          testSelection[index] = radio.value;
          var match = variants.find(function (variant) {
            return variant.options.every(function (value, i) {
              return testSelection[i] == null || value === testSelection[i];
            });
          });
          var available = !!(match && match.available);
          radio.disabled = !available;
          var label = fieldset.querySelector('label[for="' + radio.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }

    function render() {
      var selection = currentSelection();
      updateAvailability(selection);
      var variant = findVariant(selection);

      root.querySelectorAll('fieldset[data-option-index] [data-selected-value]').forEach(function (el, i) {
        el.textContent = selection[i] || '';
      });

      hiddenIdInputs.forEach(function (input) {
        input.value = variant ? variant.id : '';
      });

      if (variant) {
        if (priceEl) priceEl.textContent = variant.formatted_price;
        if (compareEl) {
          var hasCompare = variant.formatted_compare_at_price && variant.formatted_compare_at_price !== variant.formatted_price;
          compareEl.textContent = hasCompare ? variant.formatted_compare_at_price : '';
          compareEl.hidden = !hasCompare;
        }
        if (variant.featured_media_id) {
          document.dispatchEvent(new CustomEvent('ga:variant-media-change', { detail: { mediaId: variant.featured_media_id } }));
        }
      }

      if (addButton) {
        var canAdd = !!(variant && variant.available);
        addButton.disabled = !canAdd;
        addButton.setAttribute('aria-disabled', canAdd ? 'false' : 'true');
      }
      if (addLabel) {
        addLabel.textContent = !variant
          ? addLabel.dataset.unavailableText
          : !variant.available
          ? addLabel.dataset.soldOutText
          : addLabel.dataset.idleText;
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-radio]')) render();
    });

    render();
  });
})();
